const actionTypes = {
	//////////////////app//////////////////
	SET_REDIRECT: 'SET_REDIRECT',
	SET_DISPLAY_SIZE: 'SET_DISPLAY_SIZE',
	SET_API_ERROR: 'SET_API_ERROR',
	FADE_IN_MODULE: 'FADE_IN_MODULE',
	/////////////////////////////////////////////

	/////////////////modal///////////////////////
	OPEN_MODAL: 'OPEN_MODAL',
	CLOSE_MODAL: 'CLOSE_MODAL',
	/////////////////////////////////////////////

	//////////////////editor/////////////////////
	SET_EDITOR_ACTIVE_TEST: 'SET_EDITOR_ACTIVE_TEST',
	SET_TEST_NAME: 'SET_TEST_NAME',
	SET_TEST_FILTERS: 'SET_TEST_FILTERS',
	SET_EDITOR_ACTIVE_TASK: 'SET_EDITOR_ACTIVE_TASK',
	ADD_EDITOR_TASK: 'ADD_EDITOR_TASK',
	DELETE_EDITOR_TASK: 'DELETE_EDITOR_TASK',
	MOVE_EDITOR_TASK: 'MOVE_EDITOR_TASK',
	SET_EDITOR_TASKS: 'SET_EDITOR_TASKS',
	SET_EDITOR_PDF: 'SET_EDITOR_PDF',
	OPEN_EDITOR_MODULES: 'OPEN_EDITOR_MODULES',
	CLOSE_EDITOR_MODULES: 'CLOSE_EDITOR_MODULES',
	RESET_EDITOR: 'RESET_EDITOR',
	SET_EDITOR_MODE: 'SET_EDITOR_MODE',
	/////////////////////////////////////////////

	//////////////////filter/////////////////////
	GET_FILTER_LEVELS: 'GET_FILTER_LEVELS',
	GET_FILTER_CLASSES: 'GET_FILTER_CLASSES',
	GET_FILTER_SUBJECTS: 'GET_FILTER_SUBJECTS',
	GET_FILTER_TOPICS: 'GET_FILTER_TOPICS',
	GET_FILTER_TASKTYPES: 'GET_FILTER_TASKTYPES',
	GET_FILTER_DIFFICULTIES: 'GET_FILTER_DIFFICULTIES',
	// GET_FILTER_DATA: 'GET_FILTER_DATA',
	SET_FILTER_LEVEL: 'SET_FILTER_LEVEL',
	SET_FILTER_CLASS: 'SET_FILTER_CLASS',
	SET_FILTER_SUBJECT: 'SET_FILTER_SUBJECT',
	SET_FILTER_TOPIC: 'SET_FILTER_TOPIC',
	SET_FILTER_TASKTYPE: 'SET_FILTER_TASKTYPE',
	SET_FILTER_DIFFICULTY: 'SET_FILTER_DIFFICULTY',
	SET_ALL_FILTERS: 'SET_ALL_FILTERS',
	RESET_FILTER_CLASSES: 'RESET_FILTER_CLASSES',
	RESET_FILTER_SUBJECTS: 'RESET_FILTER_SUBJECTS',
	RESET_FILTER_TOPICS: 'RESET_FILTER_TOPICS',
	RESET_FILTER_TASKTYPE: 'RESET_FILTER_TASKTYPE',
	OPEN_FILTER: 'OPEN_FILTER',
	CLOSE_FILTER: 'CLOSE_FILTER',
	TOGGLE_FILTER_SECTIONS: 'TOGGLE_FILTER_SECTIONS',
	COLLAPSE_FILTER_SECTIONS: 'COLLAPSE_FILTER_SECTIONS',
	SET_FILTER_SECTIONS_LOADING: 'SET_FILTER_SECTIONS_LOADING',
	/////////////////////////////////////////////

	////////////////tasks////////////////////////
	SET_TASKLIST: 'SET_TASKLIST',
	////////////////////////////////////////////

	////////////////tests///////////////////////
	GET_USER_TESTS: 'GET_USER_TESTS',
	SET_ACTIVE_TEST: 'SET_ACTIVE_TEST',
	SAVE_TEST: 'SAVE_TEST',
	DELETE_TEST: 'DELETE_TEST',
	SORT_TESTS: 'SORT_TESTS',
	CHECK_ARCHIVE_TESTS: 'CHECK_ARCHIVE_TESTS',
	GET_ARCHIVE_TESTS: 'GET_ARCHIVE_TESTS',
	///////////////////////////////////////////

	////////////////user///////////////////////
	LOGIN: 'LOGIN',
	LOGOUT: 'LOGOUT',
	LOGIN_DEMO: 'LOGIN_DEMO',
	GET_USER_DATA: 'GET_USER_DATA',
	///////////////////////////////////////////
};

export default actionTypes;
